import {
  ButtonIcon,
  EditActionIcon,
  RoundedIconArchive,
  RoundedIconUnarchive,
} from 'components/Ui/styled';
import Tooltip from '@mui/material/Tooltip';
import MDTypography from 'components/MDTypography';
import { formatDate, formatDateTime } from 'utils/commonUtils';
import { ActionWrapperBox } from 'components/Common/common.styled';
import VisibilityRoundedIcon from '@mui/icons-material/VisibilityRounded';
import { renderCellExpand } from 'components/Common/GridCell/GridCellExpand';

const renderSpedNotessActions = (
  params,
  handleEdit,
  handleArchive,
  handleUnarchive,
  canArchivepedNotes,
  canSignOffSpedNotes,
) => {
  const isSigned = params?.row?.seifSignatureAgree === true;

  const renderViewOrEditIcon = () => {
    // 1. If signed → ALWAYS show success visibility
    if (isSigned) {
      return <VisibilityRoundedIcon color="success" />;
    }

    // 2. Not signed + user CAN sign off → show EDIT
    if (canSignOffSpedNotes) {
      return <EditActionIcon />;
    }

    // 3. Not signed + user CANNOT sign off → normal view
    return <VisibilityRoundedIcon />;
  };

  return (
    <ActionWrapperBox>
      <ButtonIcon onClick={() => handleEdit(params)}>
        {renderViewOrEditIcon()}
      </ButtonIcon>

      {!params?.row?.archived && canArchivepedNotes ? (
        <ButtonIcon onClick={() => handleArchive(params)}>
          <Tooltip title="Archive" arrow={false} placement="top">
            <RoundedIconArchive />
          </Tooltip>
        </ButtonIcon>
      ) : (
        canArchivepedNotes && (
          <ButtonIcon onClick={() => handleUnarchive(params)}>
            <Tooltip title="Un-Archive" arrow={false} placement="top">
              <RoundedIconUnarchive />
            </Tooltip>
          </ButtonIcon>
        )
      )}
    </ActionWrapperBox>
  );
};

export const studentSpedNotesColumns = (
  handleEdit,
  handleArchive,
  handleUnArchive,
  canArchivepedNotes,
  canSignOffSpedNotes,
) => [
  {
    width: 80,
    field: 'action',
    sortable: false,
    headerName: 'Action',
    disableColumnMenu: true,
    renderCell: (params) =>
      renderSpedNotessActions(
        params,
        handleEdit,
        handleArchive,
        handleUnArchive,
        canArchivepedNotes,
        canSignOffSpedNotes,
      ),
  },
  {
    flex: 1,
    headerName: 'Provider',
    field: 'serviceProvider',
    renderCell: renderCellExpand,
  },
  {
    flex: 1,
    field: 'serviceType',
    headerName: 'Service Type',
    renderCell: renderCellExpand,
  },
  {
    flex: 1,
    field: 'serviceDate',
    headerName: 'Service Date',
    renderCell: renderCellExpand,
  },
  {
    flex: 1,
    field: 'location',
    headerName: 'Location',
    renderCell: renderCellExpand,
  },
  {
    flex: 1,
    headerName: 'Status',
    field: 'sessionStatus',
    renderCell: renderCellExpand,
  },
  {
    flex: 1,
    field: 'notes',
    headerName: 'Notes',
    renderCell: renderCellExpand,
  },
];

export const studentSpedNotesListData = (spedNotesData) => {
  if (!spedNotesData || spedNotesData?.length === 0) {
    return [];
  }

  return spedNotesData.map((item) => {
    return {
      ...item,
      notes: item?.notes,
      id: item?.resourceId,
      archived: item?.archived,
      location: item?.location,
      studentId: item?.studentId,
      resourceId: item?.resourceId,
      esignature: item?.esignature,
      serviceType: item?.serviceType,
      sessionStatus: item?.sessionStatus,
      seifEsignature: item?.seifEsignature,
      createdAt: formatDate(item?.createdAt),
      updatedAt: formatDate(item?.updatedAt),
      serviceProvider: item?.serviceProvider,
      seifSignatureAgree: item?.seifSignatureAgree,
      noteSignatureAgree: item?.noteSignatureAgree,
      serviceDate: formatDateTime(item?.serviceDate),
      serviceDurationMinutes: item?.serviceDurationMinutes,
    };
  });
};

export const LabelValue = ({ label, value }) => {
  return (
    <>
      <MDTypography
        variant="body2"
        component="span"
        fontWeight="bold"
        textTransform="capitalize"
      >
        {label}:
      </MDTypography>
      <MDTypography
        color="text"
        variant="body2"
        component="span"
        fontWeight="regular"
      >
        {value || '-'}
      </MDTypography>
    </>
  );
};
